module.exports = __webpack_public_path__ + "static/img/logo@2x.620783d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo@2x.png
// module id = d3xt
// module chunks = 69